const _toCSVString = (rows) => {
  var content = '\uFEFF' // BOM for UTF-8

  rows.forEach(function (row, index) {
    // Surround everything with double quotes
    content += `"${row.join('","')}"\n`
  })

  return content
}

const _htmlRowsToTextRows = (rows) => {
  return Array.from(rows).map(row => {
    return Array.from(row.cells).map(cell => cell.textContent.trim())
  })
}

export const exportData = (tableId) => {
  const table = document.getElementById(tableId)

  const colRows = table.getElementsByTagName('thead')[0].rows
  const colTextArray = _htmlRowsToTextRows(colRows)

  const bodyRows = table.getElementsByTagName('tbody')[0].rows
  const bodyTextArray = _htmlRowsToTextRows(bodyRows)

  const rows = colTextArray.concat(bodyTextArray)

  return _toCSVString(rows)
}



// WEBPACK FOOTER //
// ./src/components/App/csvExporter.js